import React, { useEffect } from 'react';
import { Input, Table } from 'reactstrap';
import { FiArrowDownCircle, FiArrowUpCircle } from 'react-icons/fi';
import { Controller } from 'react-hook-form';

export const ProtocolStatusConfig = ({
  protocolStatus = [],
  selectedProtocolStatus = [],
  protocolStatusConfig,
  setProtocolStatusConfig,
  initialStageId,
  finalStageId,
  protocolProcess,
  control,
  setValue,
  register
}) => {
  useEffect(() => {
    register('isInitial');
    register('isFinal');
    register('disableSla');

    if (initialStageId) setValue('isInitial', `${initialStageId}`);
    if (finalStageId) setValue('isFinal', `${finalStageId}`);

    protocolStatusConfig.forEach((stage) => {
      const backendStage = protocolProcess?.protocolStatusConfig?.find(
        (s) => s.protocolStatusId === stage.id
      );
      setValue(
        `${stage.id}-shouldPauseTheSlaSolutionTimer`,
        backendStage ? backendStage.shouldPauseTheSlaSolutionTimer : false
      );
    });
  }, [
    register,
    setValue,
    initialStageId,
    finalStageId,
    protocolStatusConfig,
    protocolProcess
  ]);

  useEffect(() => {
    if (protocolStatus && protocolStatus.length > 0) {
      const config = [];
      for (const stgId of selectedProtocolStatus) {
        config.push(protocolStatus.find((stg) => stg.id === stgId));
      }
      setProtocolStatusConfig(config);
    }
  }, [selectedProtocolStatus, protocolStatus, setProtocolStatusConfig]);

  if (
    !protocolStatus ||
    !protocolStatus.length ||
    !selectedProtocolStatus ||
    !selectedProtocolStatus.length
  ) {
    return null;
  }

  const switchItems = (index1, index2) => {
    [protocolStatusConfig[index1], protocolStatusConfig[index2]] = [
      protocolStatusConfig[index2],
      protocolStatusConfig[index1]
    ];
    setProtocolStatusConfig([...protocolStatusConfig]);
  };

  const upItem = (i) => {
    const index = protocolStatusConfig.indexOf(i);
    if (index > 0) {
      switchItems(index, index - 1);
    }
  };

  const downItem = (i) => {
    const index = protocolStatusConfig.indexOf(i);
    if (index < protocolStatusConfig.length - 1) {
      switchItems(index, index + 1);
    }
  };

  return (
    <div>
      <Table bordered={true} striped={true} size="sm" className="text-center">
        <thead>
          <tr>
            <th>Status/Fase</th>
            <th>Inicial</th>
            <th>Desabilitar SLA</th>
            <th>Final</th>
            <th>Ordenar</th>
          </tr>
        </thead>
        <tbody>
          {protocolStatusConfig &&
            protocolStatusConfig.map((stage) => (
              <tr key={stage.id}>
                <td className="text-left">{stage.name}</td>
                <td>
                  <label htmlFor={stage.id}>
                    <input
                      name="isInitial"
                      type="radio"
                      value={stage.id}
                      id={stage.id}
                      defaultChecked={initialStageId === stage.id}
                      onChange={(event) =>
                        setValue('isInitial', event.target.value)
                      }
                    />
                  </label>
                </td>
                <td
                  style={{
                    verticalAlign: 'sub'
                  }}
                >
                  <Controller
                    name={`${stage.id}-shouldPauseTheSlaSolutionTimer`}
                    control={control}
                    render={(props) => (
                      <>
                        <label className="form-control-label">
                          <Input
                            type="checkbox"
                            onChange={(e) => props.onChange(e.target.checked)}
                            checked={props.value}
                          />
                        </label>
                      </>
                    )}
                    defaultValue={
                      protocolProcess.protocolStatusConfig?.find(
                        (s) => s.protocolStatusId === stage.id
                      )?.shouldPauseTheSlaSolutionTimer || false
                    }
                  />
                </td>
                <td>
                  <label htmlFor={stage.id}>
                    <input
                      name="isFinal"
                      type="radio"
                      value={stage.id}
                      id={stage.id}
                      defaultChecked={finalStageId === stage.id}
                      onChange={(event) =>
                        setValue('isFinal', event.target.value)
                      }
                    />
                  </label>
                </td>
                <td>
                  <div className="">
                    <FiArrowUpCircle
                      size={20}
                      cursor="pointer"
                      onClick={() => upItem(stage)}
                    />
                    <FiArrowDownCircle
                      style={{ marginLeft: '10px' }}
                      size={20}
                      cursor="pointer"
                      onClick={() => downItem(stage)}
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};
